module.exports = __webpack_public_path__ + "img/fudgy-buttermilk-brownies.afaf2e39.jpg";